import React from 'react';
import { Transition } from '@mantine/core';

interface SwimlaneTransitionProps {
  swimlaneIndex: number;
  isCollapsed: boolean;
  children: React.ReactNode;
}

export const SwimlaneTransition: React.FC<SwimlaneTransitionProps> = ({
  swimlaneIndex,
  isCollapsed,
  children,
}) => {
  const swimlaneTransition = {
    in: {
      maxHeight: '4000px',
      opacity: 1,
      overflow: 'hidden',
    },
    out: {
      maxHeight: '0px',
      opacity: 0,
      overflow: 'hidden',
    },
    common: {
      gridColumn: '1 / -1',
      transitionProperty: 'max-height, opacity',
    },
    transitionProperty: 'max-height, opacity',
  };

  return (
    <Transition
      key={`swimlane-content-${swimlaneIndex}`}
      mounted={!isCollapsed}
      transition={swimlaneTransition}
      duration={300}
      timingFunction="ease-in-out"
      keepMounted
    >
      {(transitionStyles) => (
        <div style={transitionStyles} className="swimlane-content">
          {children}
        </div>
      )}
    </Transition>
  );
};
